import { render, staticRenderFns } from "./PreAdd.vue?vue&type=template&id=c0b059b0&scoped=true"
import script from "./PreAdd.vue?vue&type=script&lang=js"
export * from "./PreAdd.vue?vue&type=script&lang=js"
import style0 from "./PreAdd.vue?vue&type=style&index=0&id=c0b059b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b059b0",
  null
  
)

export default component.exports